let activePlaceLink = $(".places-header__link._active").clone().html()
$(".places-header__active .places-header__link").html(activePlaceLink)

$("._js-test-search").on("input", function() {
    if ($(this).val().length > 3) {
        $(this).parents(".search-field").addClass("_active")
    } else {
        $(this).parents(".search-field").removeClass("_active")
    }
})

$(document).mouseup(function(e) {
    var div = $('.search-field');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if ($(div).addClass("_active")) {
            $(div).removeClass("_active")
        }
    }
});

$(".places-header__active").click(function() {
    $(".places-header__filter").addClass("_active")
})

$(document).mouseup(function(e) {
    var div = $('.places-header__filter');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if ($(div).hasClass("_active")) {
            $(div).removeClass("_active")
        }
    }
});